<div class="dropdown">
  <button class="btn btn-secondary dropdown-toggle" type="button" data-toggle="dropdown">
    {{ currentLanguage }}
  </button>
  <div class="dropdown-menu">
    <button
      class="dropdown-item"
      *ngFor="let lang of supportedLanguages"
      (click)="changeLanguage(lang)"
    >
      {{ lang }}
    </button>
  </div>
</div>
